


































































































































import Vue from 'vue'
import AppSearchBar from '@/components/AppSearchBar.vue'
import AppToolbar from '@/components/AppToolbar.vue'
import { debounce } from 'debounce'
import { goBack } from '@/utility/helpers'
import ScrollPosition, { ScrollPanel } from '@/types/components/ScrollPosition.interface'
export default Vue.extend({
    components: { AppSearchBar, AppToolbar },
    props: {
        //  Determines if our back button is hidden
        backHidden: {
            type: Boolean,
            default: false
        },
        //  Determines if we show border on the bottom style
        clearBottom: {
            type: Boolean,
            default: false
        },
        //  Determines if we show border on the top style
        clearTop: {
            type: Boolean,
            default: false
        },
        //  Determines if a bottom border is shown on the top slot
        divider: {
            type: Boolean,
            default: true
        },
        //  The icon that overrides the 'Details' button
        detailsIcon: {
            type: String,
            default: null
        },
        // Replaces the details text
        detailsText: {
            type: String,
            required: false,
            default: 'Details'
        },
        //  The width of the right panel
        rightWidth: {
            type: String,
            default: null
        },
        //  Determines if we display the divider between our pages
        leftDivider: {
            type: Boolean,
            default: true
        },
        //  The width of the left panel
        leftWidth: {
            type: String,
            default: null
        },
        // Determines if a linear progress loader is shown between the toolbar and content
        loader: {
            type: Boolean,
            required: false,
            default: false
        },
        //  The title displayed in the top toolbar
        toolbar: {
            type: Object,
            default: null
        },
        // Determines if we ignore height calculations
        full: {
            type: Boolean,
            default: false
        },
        //  Determines if we include an auto overflow
        scrollable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //  Determines if the mobile search should be shown
            showMobileSearch: null,
            //  The current step (used for mobile only)
            step: 1,
            //  Styling for mobile panels
            mobileStyle: {
                flexGrow: 1,
                height: '100%',
                maxWidth: '100%',
                minWidth: '100%',
                width: '0px'
            }
        }
    },
    computed: {
        containerStyle(): object {
            //  Grab our height prop
            const height = this.$slots['left-top']
                ? { 'max-height': 'calc(100% - 53px)' }
                : {}

            //  Check if we included the scrollable prop
            const isScrollable = this.scrollable

            //  Return styles based on these
            return {
                height: '100%',
                'overflow-y': isScrollable ? 'auto !important' : '',
                ...height
            }
        },
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        stepperStyle(): object {
            //  Our margin depends on our breakpoint
            const margin =
                {
                    xs: '0px 0px 0px 0px',
                    sm: '0px 10px 0px 10px'
                }[this.$vuetify.breakpoint.name] || '0px 20px 0px 10px'

            return {
                background: 'white',
                borderRadius: '10px',
                overflow: 'hidden',
                margin: margin,
                boxShadow: this.$vuetify.breakpoint.smAndDown
                    ? ''
                    : '5px 5px 10px 0px rgba(189,189,189,1)',
                height: '100%'
            }
        },
        //  The style applied to 'bottom' slots
        styleBottom(): object {
            //  If clear bottom is true, just return nothing
            if (this.clearBottom) return {}
            return {
                borderTop: `1px solid ${this.$colors.grey.lighten2}`
            }
        },
        styleLeft(): object {
            return {
                padding: '0px',
                maxWidth: this.leftWidth,
                position: 'relative',
                // height: 0,
                maxHeight: '100%'
                // minHeight: '100%'
            }
        },
        styleRight(): object {
            return {
                padding: '0px',
                maxWidth: this.rightWidth,
                borderLeft: this.leftDivider
                    ? `1px solid ${this.$colors.grey.lighten2}`
                    : 'none',
                // height: 0,
                maxHeight: '100%'
                // minHeight: '100%'
            }
        },
        //  The style applied to the 'top' slots
        styleTop(): object {
            //  If clearTop is true, don't have a border on bottom
            const borderStyle = this.clearTop
                ? ''
                : `1px solid ${this.$colors.grey.lighten2}`
            return {
                display: 'flex',
                borderBottom: borderStyle,
                minHeight: '56px'
            }
        },
        //  The style applied to the page wrapper
        styleWrapper(): object {
            return {
                background: 'white',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                margin: this.$vuetify.breakpoint.smAndDown
                    ? '0px 10px 0px 10px'
                    : '0px 20px 0px 10px',
                boxShadow: this.$vuetify.breakpoint.smAndDown
                    ? ''
                    : '5px 5px 10px 0px rgba(189,189,189,1)',
                height: '100%'
            }
        }
    },
    methods: {
        onContentScroll: debounce(function (event: Event, panel: string): void {
            //  Get the DOM from the event
            const content = event.target as HTMLDivElement

            //  Get the height of the content
            const contentHeight = content.clientHeight

            //  Get current scroll location
            const current = content.scrollTop

            //  Check for top - if current position is zero
            const top = current === 0

            //  Check for bottom - if current position is greater than scrollHeight of the element
            const bottom = Math.ceil(current + contentHeight) >= content.scrollHeight

            //  Update the scrollPosition state
            this.$store.commit(`scrollPosition${panel}Set`, {
                current: current,
                top: top,
                bottom: bottom
            })
        }, 200),
        //  This determines the behavior of the 'back' button...goBack, or handle mobile navaigation
        routeBack(hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Our toolbar's back button
            let btn = this.toolbar.left && this.toolbar.left[0]

            //  If the button has a back callback, it overrides all other handling
            if (this.toolbar.back) return this.toolbar.back(btn)

            //  If we are NOT on a mobile device, we always use the global back function
            if (!this.$vuetify.breakpoint.xsOnly) return goBack(btn)

            //  Else, If we're on step 1, we use the global back function
            if (this.step === 1) return goBack(btn)

            //  Else, if we're on step 2, the back button takes use to step 1
            if (this.step === 2) this.step = 1
        },
        //  Scroll a panel to a specific position
        scrollTo(position: ScrollPosition) {
            //  Get the content element for the position
            const el = this.$refs[position.panel]

            //  Set the scroll position
            el.scrollTop = position.current
        },
        setStep(step: number): void {
            this.step = step
        }
    },
    watch: {
        step(val: number): void {
            this.$emit('currentStep', val)
        }
    }
})
